import SpecialSale from 'src/dispensary/specials/sale';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';
import { getDispensaryServerSideProps } from 'src/utils/ssr/get-dispensary-server-side-props';

export const getServerSideProps = getDispensaryServerSideProps;

SpecialSale.layout = CoreMenuLayout;
export default SpecialSale;
